module.exports = __webpack_public_path__ + "static/media/pin.708adb2e.svg";